import { render, staticRenderFns } from "./Capture.vue?vue&type=template&id=5b2d2dc4"
import script from "./Capture.vue?vue&type=script&lang=js"
export * from "./Capture.vue?vue&type=script&lang=js"
import style0 from "./Capture.vue?vue&type=style&index=0&id=5b2d2dc4&prod&lang=css"
import style1 from "./Capture.vue?vue&type=style&index=1&id=5b2d2dc4&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports